import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Box,
  Chip,
} from '@mui/material';
import {
  DISCREPANCY_SOURCE_SYSTEM_OPTIONS,
  DISCREPANCY_RUN_STATUS_OPTIONS,
  DISCREPANCY_RUN_STATUS_LABELS,
  DISCREPANCY_RUN_STATUS_COLORS,
} from '../../../constants/discrepancyMappingStatuses';
import { FilterBar } from './styles';
import { getChipSx } from './chipStyles';

// Mirrors the Project Status filter style on the projects page: chips inside
// the input for selected values, chips inside MenuItems, no checkboxes.
const renderStatusChips = (selected) => {
  if (!selected || selected.length === 0) {
    return <em>None</em>;
  }
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {selected.map((value) => (
        <Chip
          key={value}
          label={DISCREPANCY_RUN_STATUS_LABELS[value] || value}
          size="small"
          sx={getChipSx(DISCREPANCY_RUN_STATUS_COLORS[value])}
        />
      ))}
    </Box>
  );
};

const RunsFilterBar = ({ sourceSystem, status, onChange }) => {
  const handleSource = (event) => {
    const value = event.target.value;
    onChange({ sourceSystem: value, status });
  };
  const handleStatus = (event) => {
    const value = event.target.value;
    onChange({ sourceSystem, status: typeof value === 'string' ? value.split(',') : value });
  };

  return (
    <FilterBar>
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="dmd-source-label">Source</InputLabel>
        <Select
          labelId="dmd-source-label"
          label="Source"
          value={sourceSystem || ''}
          onChange={handleSource}
        >
          <MenuItem value=""><em>All</em></MenuItem>
          {DISCREPANCY_SOURCE_SYSTEM_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel id="dmd-status-label">Status</InputLabel>
        <Select
          labelId="dmd-status-label"
          multiple
          value={status || []}
          onChange={handleStatus}
          input={<OutlinedInput label="Status" />}
          renderValue={renderStatusChips}
        >
          {DISCREPANCY_RUN_STATUS_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <Chip
                label={opt.label}
                size="small"
                sx={getChipSx(DISCREPANCY_RUN_STATUS_COLORS[opt.value])}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </FilterBar>
  );
};

export default RunsFilterBar;
